module.exports = __webpack_public_path__ + "img/biaoti_xiaoqi.a7d336ca.png";